<template>
  <div>
    <div v-if="firstTime">我是简介</div>
    <router-view></router-view>
    <div class="common_nav">
      <el-select v-model="modelValue" @change="changeProject" placeholder="请选择">
        <el-option v-for="item in projectArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </div>
    <imView v-if="isIm"></imView>
  </div>
</template>

<script>
  import {
    getCompangModules,
    login,
    permission,
    getAllModules,
    checkLogin
  } from '@/api/user'
  import { localRead, localRemove, localSave } from '@/utils/tools'
  import { addSysRouter } from '@/router/permission'
  import imView from '@/views/commonPage/im.vue'
  import imStore from '@/store/modules/im'
  import Util from '@/utils/IM/tradeDataUtil'

  export default {
    components: { imView },
    data() {
      return {
        projectArr: [], //项目集合
        modelValue: '',
        isIm: false
      }
    },
    computed: {
      firstTime: function() {
        return !this.$route.query.label
      }
    },
    created() {
      this.getCurrentModel()
    },
    methods: {
      getCurrentModel() {
        let routerLabel, userId, userInfo
        routerLabel = this.$route.query.label
        userId = JSON.parse(localRead('userId'))
        getCompangModules(userId).then(res => {
          this.projectArr = res.result
          localSave('sysCode', JSON.stringify(this.projectArr))
          this.projectArr.filter(item => {
            if (item.code == routerLabel) {
              this.modelValue = item.id
            }
          })
          for (let i in this.projectArr) {
            if (this.projectArr[i].code == 'IM') {
              if (Util.isNotEmpty(localRead('sys_userInfo_IM'))) {
                this.isIm = true
              } else {
                imStore.dispatch('setUserInfoIM', this.projectArr[i].id).then(() => {
                  this.isIm = true
                })
              }
            }
          }
        })
      },
      changeMenu(routerLabel) {
        permission(1).then(res => {
          const { result } = res
          let getRouter = result
          localSave(
            routerLabel + '_router',
            JSON.stringify(getRouter)
          )
          addSysRouter(getRouter, routerLabel)
          //跳转到公共页
          this.$router.push({
            path: '/Layout',
            query: { label: routerLabel }
          })
          const { name } = this.$route
          if (name) {
            this.$store.dispatch('tagsView/delAllViews', this.$route)
          }
        })
      },
      changeProject(val) {
        let newRouterLabel //切换新系统的标识
        for (let i in this.projectArr) {
          if (this.projectArr[i].id == val) {
            newRouterLabel = this.projectArr[i].code
          }
        }
        this.$store
          .dispatch('user/changeSysterm', val)
          .then(() => {
            let routerLabel = this.$route.query.label
            //项目切换之后清除之前项目的session
            localRemove(routerLabel + '_sys_userInfo')
            localRemove(routerLabel + '_router')
            localRemove(routerLabel + '_admin_token')
            localRemove(routerLabel + '_menus')
            localRemove(routerLabel + '_buttons')
            window.SITE_CONFIG['routerLabel'] = newRouterLabel
            //调菜单获取菜单添加路由
            this.changeMenu(newRouterLabel)
            //存储按钮权限
            this.saveButtonControls()
          })
          .catch(() => {
            //表示没有切换成功 还是原来的值
            let label = this.$route.query.label
            this.projectArr.map(item => {
            if (label == item.code) {
              this.modelValue = item.id
            }
          })
          })
      },
      saveButtonControls() {
        permission(2).then(response => {
          const { result } = response
          let buttonsControl = result
          localSave(
            window.SITE_CONFIG['routerLabel'] + '_buttons',
            JSON.stringify(buttonsControl)
          )
        })
      }
    }
  }
</script>

<style lang="scss">
  .common_nav {
    position: absolute;
    top: 2px;
    right: 0;
    padding: 5px 5px;
    color: #333;

    .right_serve {
      width: 200px;
      height: 100%;
    }
  }
</style>
